import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "button"];

  connect() {
    // Close menu when clicking outside
    this.boundClickOutside = this.closeOnClickOutside.bind(this);
    document.addEventListener("click", this.boundClickOutside);
  }

  disconnect() {
    document.removeEventListener("click", this.boundClickOutside);
  }

  toggle() {
    this.menuTarget.classList.toggle("hidden");

    // Update button aria-expanded for accessibility
    const isExpanded = !this.menuTarget.classList.contains("hidden");
    this.buttonTarget.setAttribute("aria-expanded", isExpanded);
  }

  close() {
    this.menuTarget.classList.add("hidden");
    this.buttonTarget.setAttribute("aria-expanded", "false");
  }

  closeOnClickOutside(event) {
    // Close menu if clicking outside of navbar
    if (!this.element.contains(event.target)) {
      this.close();
    }
  }

  // Close menu when any menu link is clicked
  closeOnLinkClick() {
    this.close();
  }
}
